<template>
  <section class="w-100 d-flex flex-column justify-content-center align-items-center">
    <h1 class="font-weight-bold">404 Not Found</h1>
    <p class="text-muted">お探しのページは見つかりませんでした。</p>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
